var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uk-margin-medium-bottom",
    attrs: {
      "uk-tab": ""
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-product',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.basics')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-protocols',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.protocols')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.protocols) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-adapters',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.adapters')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.adapters) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-appliances',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.appliances')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.appliances) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-cameras',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.cameras')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.cameras) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-climate-devices',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.climateDevices')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.climateDevices) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-extensions',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.extensions')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.extensions) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-gateway-bridges',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.gatewayBridges')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.gatewayBridges) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-door-locks',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.doorLocks')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.doorLocks) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-lightnings',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.lightnings')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.lightnings) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-motion-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.motionSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.motionSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-mounted-devices',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.mountedDevices')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.mountedDevices) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-outdoor',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.outdoor')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.outdoor) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-remote-controls',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.remoteControls')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.remoteControls) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-internet-routers',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-native"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.internetRouters')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.internetRouters) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-shutter-and-gates',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.shutterAndGates')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.shutterAndGates) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-sirens',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.sirens')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.sirens) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-smoke-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.smokeSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.smokeSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-speakers',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.speakers')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.speakers) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-various-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.variousSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.variousSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-switches',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.switches')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.switches) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-door-window-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.doorWindowSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.doorWindowSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-integrated-systems',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.integratedSystems')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.integratedSystems) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-water-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.waterSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.waterSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-weather-sensors',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-active"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.weatherSensors')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.weatherSensors) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'edit-kompa-media-receivers',
        params: {
          id: _vm.id
        }
      },
      "exact-active-class": "uk-native"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('tabs.mediaReceivers')) + "\n        "), (_vm.kompaProduct && _vm.kompaProduct.mediaReceivers) ? _c('span', [_vm._v("*")]) : _vm._e()])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-001c52ed","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/KompaEditNavigation.vue
// module id = 1827
// module chunks = 0